import { authClient } from '@/lib/auth-client'
import { LOGOUT_ROUTE } from '@/lib/logout-route'

/**
 * Navigate to the logout Route Handler.
 *
 * Deliberately a full document navigation rather than `useRouter().push()`:
 * the destination is a Route Handler, not a page, and its response both sets a
 * cookie and redirects off-site to the identity provider — neither of which the
 * client-side router follows. Tearing the document down is also the point here,
 * since it discards any in-memory auth state.
 */
function redirectToLogout(): void {
  window.location.href = LOGOUT_ROUTE
}

/**
 * Sign out, then leave — whether or not clearing the local session succeeded.
 *
 * Both arms redirect on purpose. Sign-out is offered on the error screen, which
 * is reached precisely when something is already broken, so gating the redirect
 * on a successful call is how it ends up doing nothing at all in the one case
 * that matters. Leaving still clears the environment cookie and tears down the
 * identity provider's session, which beats stranding someone on a page they
 * believe they just signed out of.
 */
export function signOutAndRedirect(): void {
  void authClient.signOut().then(redirectToLogout, redirectToLogout)
}
